module.exports = __webpack_public_path__ + "frontend/images/og/og.png?8f616abbc5cd8f707b92da87902aa1d4";